import { createRef, useEffect } from 'react';
import { hidden } from './styles';

/** HACK: Фикс фронтона от 25 ноября 2021 года
 * Из комментариев https://github.lmru.tech/adeo/lmru--triffle--pdp/pull/121
 * Она вызывает принудительную перерисовку лэйаута в браузере в промежутке между сменой классов. https://gist.github.com/paulirish/5d52fb081b3570c81e3a
 * Проблема возникает именно из-за того, как Сафари рендерит SVG
 * Возможно уже неактуально.
 */
export const useForceRenderEffect = (value: number | (number & readonly string[])) => {
  const ref = createRef<HTMLDivElement>();

  useEffect(() => {
    const el = ref.current;
    if (el) {
      el.classList.add(hidden);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      el.offsetHeight;
      el.classList.remove(hidden);
    }
  }, [value, ref]);

  return ref;
};
